import React from 'react';
import ReactMarkdown from 'react-markdown';
import { graphql, Link } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { Layout } from '@components';
import styled from 'styled-components';
import { Main, theme } from '@styles';
const { colors } = theme;

const StyledPostContainer = styled(Main)`
  max-width: 1000px;
  .markdown-html {
    margin-bottom: 100px;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 2em 0 1em;
    }

    code {
      font-size: 12px;
    }

    pre {
      background-color: #112340;
      overflow: auto;
      padding: 1.25em;
      font-family: 'SF Mono,Fira Code,Fira Mono,Roboto Mono,Lucida Console,Monaco,monospace';
    }
    blockquote {
      border-left-color: #ff0000;
      background-color: ${colors.lightNavy};
      p {
        margin: 1em 0;
        padding-top: 5px;
        line-height: 1.5;
        font-size: 16px;
        color: ${colors.lightSlate};
      }
    }
  }
`;

const StyledPostHeader = styled.header`
  margin-bottom: 50px;
  .tag {
    margin-right: 10px;
  }
`;

const StyledPostDes = styled.div`
  margin-bottom: 70px;
`;

const PostTemplate = ({ data, location }) => {
  const { published_at, title, description, content, category } = data.strapiArticle;

  return (
    <Layout location={location}>
      <Helmet>
        <title>{title} | Jane Li</title>
        <link rel="canonical" href="https://trust-janeli.netlify.app/blog" />
      </Helmet>

      <StyledPostContainer>
        <span className="breadcrumb">
          <span className="arrow">&larr;</span>
          <Link to="/blog">All Blogs</Link>
        </span>
        <StyledPostHeader>
          <h1 className="medium-title">{title}</h1>
          <p className="subtitle">
            <time>
              {new Date(published_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </time>
            <span>&nbsp;&nbsp;&nbsp;&mdash;&nbsp;</span>#{category.name}
          </p>
        </StyledPostHeader>
        <StyledPostDes> {description}</StyledPostDes>
        <ReactMarkdown source={content} className="markdown-html" />
      </StyledPostContainer>
    </Layout>
  );
};

export default PostTemplate;

PostTemplate.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export const pageQuery = graphql`
  query($strapiId: Int!) {
    strapiArticle(strapiId: { eq: $strapiId }) {
      published_at
      title
      description
      content
      category {
        id
        name
      }
    }
  }
`;
